var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPatientIcon = function SvgPatientIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#313336",
    fillOpacity: 0.03
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_455_4023)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7266 10.2942C14.7266 11.506 13.7442 12.4884 12.5324 12.4884C11.3206 12.4884 10.3382 11.506 10.3382 10.2942C10.3382 9.08237 11.3206 8.10001 12.5324 8.10001C13.7442 8.10001 14.7266 9.08237 14.7266 10.2942ZM16.4144 15.0201C16.4144 16.2319 14.6764 17.2143 12.5324 17.2143C10.3884 17.2143 8.65039 16.2319 8.65039 15.0201C8.65039 13.8083 10.3884 12.8259 12.5324 12.8259C14.6764 12.8259 16.4144 13.8083 16.4144 15.0201ZM13.1177 14.3973C13.302 14.2037 13.6008 14.2037 13.7851 14.3973L14.0724 14.6808C14.0979 14.7059 14.1397 14.7059 14.1652 14.6808L14.4525 14.3973C14.6368 14.2037 14.9356 14.2037 15.1199 14.3973C15.3041 14.5909 15.3041 14.9047 15.1199 15.0983L14.2383 16.0242C14.1738 16.0919 14.0637 16.0919 13.9993 16.0242L13.1177 15.0983C12.9334 14.9047 12.9334 14.5909 13.1177 14.3973Z",
    fill: "#313336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_455_4023",
    x: -1.29247,
    y: -1.84285,
    width: 27.6494,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImage",
    stdDeviation: 4.97143
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_455_4023"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_455_4023",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPatientIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "patient-icon.bfabe4f5073d8e3014172c86143b992c.svg";